import React from 'react';
import PropTypes from 'prop-types';

import CutoffField from '../../CutoffsFields/CutoffField';

import { round5 } from 'utilities/math';

class CutoffsFieldsComponent extends React.PureComponent {
  renderLeftField = (inputClassName, label, wrapperClass) => (
    <CutoffField
      id="b-left-cutoff"
      name="bLeftCutoff"
      label={label}
      step={1}
      inputClass={inputClassName}
      wrapperClass={wrapperClass}
      onChange={this.props.onLeftCutoffChange}
      validate={this.props.validateLeftCutoffFn}
    />
  )

  renderRightField = (inputClassName, label, wrapperClass) => (
    <CutoffField
      id="b-right-cutoff"
      name="bRightCutoff"
      label={label}
      step={1}
      inputClass={inputClassName}
      wrapperClass={wrapperClass}
      onChange={this.props.onRightCutoffChange}
      validate={this.props.validateRightCutoffFn}
    />
  )

  getRoundingAlpha = alpha => {
    let roundingAlpha = `= ${round5(alpha)}`;
    const min = 0.00001;
    const max = 0.99999;
    if (alpha < min && alpha > 0) {
      roundingAlpha = `< ${min}`;
    }
    if (alpha > max && alpha < 1) {
      roundingAlpha = `> ${max}`;
    }
    if (alpha === -1) {
      roundingAlpha = '= error';
    }
    return roundingAlpha;
  }

  render () {
    const { binomialAlpha, isCenterCutoffChosen, isLeftCutoffFieldVisible, isRightCutoffFieldVisible, isEqualCutoffChosen } = this.props;
    return (
      <div>
        {isLeftCutoffFieldVisible && !isRightCutoffFieldVisible && (
          <div className="flex baseline main-input--inline mb-5 width-48">
            {this.renderLeftField('max-80', 'P( x \u2264', 'width-full')}
            <span className="main-input__label mr--5">)</span>
          </div>
        )}

        {isRightCutoffFieldVisible && !isLeftCutoffFieldVisible && (
          <div className="flex baseline main-input--inline mb-5 width-48">
            {this.renderLeftField('max-80', 'P( x \u2265', 'width-full ')}
            <span className="main-input__label mr--5">)</span>
          </div>
        )}
        {isRightCutoffFieldVisible && isLeftCutoffFieldVisible && !isCenterCutoffChosen && (
          <div className="flex space-between main-input--inline">
            {this.renderLeftField('max-80', 'P( x \u2264', 'width-48 ')}
            <div className="flex baseline main-input--inline width-48">
              {this.renderRightField('max-80', ' or x \u2265', ' width-full')}
              <span className="main-input__label mr--5">)</span>
            </div>
          </div>
        )}
        {isRightCutoffFieldVisible && isLeftCutoffFieldVisible && isCenterCutoffChosen && (
          <div className="flex space-between main-input--inline">
            {this.renderLeftField('max-80', 'P( x \u2265', 'width-48 ')}
            <div className="flex baseline main-input--inline width-48">
              {this.renderRightField('max-75', 'and x \u2264', ' width-full')}
              <span className="main-input__label mr--5">)</span>
            </div>
          </div>
        )}
        {isEqualCutoffChosen && (
          <div className="flex baseline main-input--inline mb-5 width-48">
            {this.renderLeftField('max-80', 'P( x =', 'width-full')}
            <span className="main-input__label mr--5">)</span>
          </div>
        )}
        <div id="b-alpha" className="width-48 mt-20 flex baseline justify-end">

          <span className="inline-block width-90">{this.getRoundingAlpha(binomialAlpha)}</span>
        </div>
      </div>
    );
  }
}

CutoffsFieldsComponent.propTypes = {
  isEqualCutoffChosen: PropTypes.bool.isRequired,
  isCenterCutoffChosen: PropTypes.bool.isRequired,
  isLeftCutoffFieldVisible: PropTypes.bool.isRequired,
  isRightCutoffFieldVisible: PropTypes.bool.isRequired,

  onLeftCutoffChange: PropTypes.func.isRequired,
  onRightCutoffChange: PropTypes.func.isRequired,
  validateLeftCutoffFn: PropTypes.func.isRequired,
  validateRightCutoffFn: PropTypes.func.isRequired,

  binomialAlpha: PropTypes.number.isRequired
};

export default CutoffsFieldsComponent;
